import { SearchUserQueryString } from '@/app/shared/filter';
import { PaginationModel, Product, ProductModel } from '@/app/shared/interface/product.interface';
import { CommonService } from '@/app/shared/services/common.service';
import { ProductService } from '@/app/shared/services/product.service';
import { QueryStringService } from '@/app/shared/services/querystring.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EMPTY, Subject, Subscription, debounceTime, switchMap } from 'rxjs';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { useSafeTimeout } from '@/app/shared/ssr-util';

@Component({
  selector: 'app-wish-list',
  templateUrl: './wish-list.component.html',
  styleUrl: './wish-list.component.scss'
})
export class WishListComponent implements OnInit, OnDestroy {

  wishlist: Product[] = [];
  wishlistIds: number[] = [];
  public inputText: string;
  private readonly debounceTimeMs = 500; // Set the debounce time (in milliseconds)
  private searchSubject = new Subject<string>();
  private subscriptions = new Subscription();
  public searchUserQuery: SearchUserQueryString = new SearchUserQueryString();

  private safeTimeout = useSafeTimeout();

  constructor(
    private queryStringService: QueryStringService,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private productService: ProductService,
    private cookieService: SsrCookieService
  ) {
  }

  ngOnInit() {
    this.subscriptions.add(this.queryStringService.eventChangeQueryString.subscribe(() => {
      this.searchUserQuery = this.queryStringService.getQueryString(new SearchUserQueryString());
    }));

    // switchMap: mỗi lần đổi query (phân trang) chỉ giữ 1 subscription tới wishlist.
    // Bỏ/thêm yêu thích từ app-product-box-vertical => setWishlist => tải lại danh sách.
    this.subscriptions.add(this.route.queryParams.pipe(
      switchMap(params => {
        if (params["s"]) {
          this.inputText = params["s"];
          this.search(this.inputText);
          return EMPTY;
        }
        return this.commonService.getWishlist;
      })
    ).subscribe((res: number[]) => {
      if (res && res.length > 0) {
        this.wishlistIds = res;
        this.getWishList();
      }
      else {
        this.wishlistIds = [];
        this.wishlist = [];
      }
    }));

    this.subscriptions.add(this.searchSubject.pipe(debounceTime(this.debounceTimeMs)).subscribe((searchValue) => {
      this.searchUserQuery.value = this.inputText;
      this.queryStringService.changeQueryString(this.searchUserQuery);
    }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getWishList() {
    this.search("");
  }

  search(value: string) {
    let body: any;
    let request = this.queryStringService.buildFetchingModel();

    if (value) {
      body = {
        limit: request.limit,
        offset: request.offset,
        searchTerm: value,
        maxNumberOfResult: 20
      }
    }
    else {
      body = {
        limit: request.limit,
        offset: request.offset,
        productIds: this.wishlistIds
      }
    }

    const token = this.cookieService.get('token');
    const products$ = token
      ? this.productService.getProductsForMember(JSON.stringify(body))
      : this.productService.getProductsForGuest(JSON.stringify(body));

    products$.subscribe({
      next: (res: ProductModel) => {
        if (res.products) {
          this.wishlist = res.products;

          // currentTier dùng cho progress bar trong app-product-box-vertical
          this.wishlist.forEach((product: Product) => {
            product.currentTier = product.tieredPrices?.find((x: any) => x.pricingTableId == product.appliedPricingTable?.id);
          });

          let pagination: PaginationModel = {
            limit: body.limit,
            offset: body.offset,
            searchTerm: body.searchTerm,
            totalItems: res.total,
          };
          this.safeTimeout(() => {
            this.queryStringService.changePagination(pagination);
          }, 10);
        }
      }
    });
  }

  input() {
    if (this.inputText) {
      this.searchSubject.next(this.inputText);
    }
    else if (this.inputText != undefined) {
      this.searchSubject.next(this.inputText);
      this.getWishList();
    }
  }
}
